import CONSTANTES_AMBIENTE from '../../constants/constantesAmbiente';

export function isTenantNCE() {
    const tenant = JSON.parse(sessionStorage.getItem('tenant'));
    if(tenant && tenant.modeloOferta && (tenant.modeloOferta == CONSTANTES_AMBIENTE.CONFIGURACOES.TENANT_MODELO_OFERTA_NCE)){
        return true;
    }
    return false;
}

export function isTenantLegacy() {
    const tenant = JSON.parse(sessionStorage.getItem('tenant'));
    if(tenant && tenant.modeloOferta && (tenant.modeloOferta == CONSTANTES_AMBIENTE.CONFIGURACOES.TENANT_MODELO_OFERTA_LEGACY)){
        return true;
    }
    return false;
}